import { render, staticRenderFns } from "./properties-block-inline.vue?vue&type=template&id=351d032e&scoped=true"
import script from "./properties-block-inline.vue?vue&type=script&lang=js"
export * from "./properties-block-inline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351d032e",
  null
  
)

export default component.exports